import React from 'react';
import TimeAgo from 'react-timeago'; 

export default class UserChatList extends React.Component {
	renderUnreadMessagesCount(data){
		if (data.UnreadMessage !== undefined){
			let num = data.UnreadMessage
			if(num > 99){
				num = '99+'
			}
			return(
				<div>
					<span className="badge badge-pill badge-danger sidebar-notification-counter">
						{num}
					</span>
				</div>
			)
		}else{
			return null
		}
	}

	renderLastLogin(data){
		// console.log(data)
		if(data.Online || this.props.IsBot){
			return (
				null
			);
		}else if(data.LastOnline === null){
			return (
				<small className="text-muted mr-3">
					<i className="icon-clock"></i>&nbsp;Never Logged In
				</small>
			)
		}else{
			return (
        		<small className="text-muted mr-3">
        			<i className="icon-clock"></i>&nbsp;<TimeAgo date={this.props.ListData.LastOnline} />
        		</small>
			);
		}
	}

	render(){
		const ListData = this.props.ListData
		return (
			<div>
	            <div 
	            	className={"m-0 py-3 callout callout-" + this.props.Color} 
	            	role="button" 
	            	onClick={() => this.props.OnUserClick(ListData)}
	            	style = {{color : this.props.TextColor}}
	            	>
		                <div>
		                	<strong>{ListData.FirstName + ' ' + ListData.LastName}</strong>
		                </div>
		                {this.renderUnreadMessagesCount(ListData)}
            			<span>
		                	{this.renderLastLogin(ListData)}
                    	</span>
	            </div>
	            <hr className="mx-3 my-0"/>
	        </div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/App/chat/ChatSidebar/helper/component/child/UserChatList.js